const EN_WORDS_EXCEPTION = [
    'a',
    'an',
    'and',
    'as',
    'at',
    'but',
    'by',
    'down',
    'en',
    'for',
    'from',
    'in',
    'like',
    'near',
    'nor',
    'of',
    'off',
    'on',
    'onto',
    'over',
    'into',
    'out',
    'or',
    'past',
    'per',
    'so',
    'the',
    'to',
    'up',
    'upon',
    'v',
    'v.',
    'vs',
    'vs.',
    'via',
    'with',
    'yet',
];

export default EN_WORDS_EXCEPTION;
